
import { formatDateTrackingHistory } from "@/app/infrastructures/misc/Utils";
import { KulionerHistory, KulionerOrder } from "@/domain/entities/Kulioner";
import { prop, Vue } from "vue-class-component";
import { ORDER_STATUS, ORDER_STATUS_DATA } from "../../utils";

class Props {
  detail = prop<KulionerOrder>({
    default: () => new KulionerOrder()
  });
  loading = prop<boolean>({
    default: true
  });
}
class HistoryOrder extends Vue.with(Props) {
  get steps(): KulionerHistory[] {
    if (this.loading) return Array(5).fill(new KulionerHistory());

    const { histories } = this.detail;

    const mappingData = Object.keys(ORDER_STATUS_DATA).map(
      (key) =>
        new KulionerHistory({
          ...histories.find((item) => item.status === key),
          status: key,
          label: ORDER_STATUS(key).label
        })
    );

    const hasCancelled = histories.some(this.isCancelled);

    return mappingData.filter((item) =>
      hasCancelled
        ? histories.some((h) => h.status === item.status)
        : !this.isCancelled(item)
    );
  }
  isLastIndex(index: number) {
    return index === this.steps.length - 1;
  }

  get lastActiveIndex(): number {
    return this.steps.filter((e) => e.createdAt).length - 1;
  }
  get cancelledIndex(): number {
    return this.steps.findIndex((e) => this.isCancelled(e));
  }

  formatDate(date: string) {
    return formatDateTrackingHistory(date, "");
  }

  isCancelled(step: KulionerHistory): boolean {
    return step.status?.toUpperCase() === "CNCWRF";
  }
  getLineClass(index: number, side: "left" | "right"): string {
    const isLeft = side === "left";

    if (isLeft && !index) return "bg-transparent";
    if (!isLeft && index === this.steps.length - 1) return "bg-transparent";

    const cancelIndex = isLeft ? this.cancelledIndex : this.cancelledIndex - 1;
    const activeIndex = isLeft
      ? this.lastActiveIndex
      : this.lastActiveIndex - 1;

    if (index === cancelIndex) return "bg-red-lp-100 text-red-lp-100";
    if (index <= activeIndex) return "bg-green-lp-100 text-green-lp-100";

    return "bg-gray-lp-600 text-gray-lp-600";
  }
}
export default HistoryOrder;
